import React from 'react';
import VideoOptimization from './VideoOptimization';
import VideoMotionControls from './VideoMotionControls';

interface VideoAdvancedControlsProps {
  selectedVideoProvider: 'runway' | 'ltx';
  isOptimizing: boolean;
  optimizationResult: any;
  showOptimizationResult: boolean;
  setShowOptimizationResult: (show: boolean) => void;
  handleAutoOptimize: () => void;
  applyOptimizedParams: () => void;
  copyOptimizationResult: () => void;
  showVideoMotionAccordion: boolean;
  setShowVideoMotionAccordion: (show: boolean) => void;
  selectedMotionTemplate: string;
  setSelectedMotionTemplate: (template: string) => void;
  selectedMotionTypes: string[];
  setSelectedMotionTypes: (types: string[]) => void;
  motionIntensity: string;
  setMotionIntensity: (intensity: string) => void;
  motionSpeed: number;
  setMotionSpeed: (speed: number) => void;
  videoPrompt: string;
}

const VideoAdvancedControls: React.FC<VideoAdvancedControlsProps> = ({
  selectedVideoProvider,
  isOptimizing,
  optimizationResult,
  showOptimizationResult,
  setShowOptimizationResult,
  handleAutoOptimize,
  applyOptimizedParams,
  copyOptimizationResult,
  showVideoMotionAccordion,
  setShowVideoMotionAccordion,
  selectedMotionTemplate,
  setSelectedMotionTemplate,
  selectedMotionTypes,
  setSelectedMotionTypes,
  motionIntensity,
  setMotionIntensity,
  motionSpeed,
  setMotionSpeed,
  videoPrompt,
}) => {
  if (selectedVideoProvider !== 'runway') {
    return null; // Only show advanced controls for Runway
  }

  return (
    <>
      <VideoOptimization
        isOptimizing={isOptimizing}
        optimizationResult={optimizationResult}
        showOptimizationResult={showOptimizationResult}
        setShowOptimizationResult={setShowOptimizationResult}
        handleAutoOptimize={handleAutoOptimize}
        applyOptimizedParams={applyOptimizedParams}
        copyOptimizationResult={copyOptimizationResult}
        videoPrompt={videoPrompt}
      />

      <VideoMotionControls
        showVideoMotionAccordion={showVideoMotionAccordion}
        setShowVideoMotionAccordion={setShowVideoMotionAccordion}
        selectedMotionTemplate={selectedMotionTemplate}
        setSelectedMotionTemplate={setSelectedMotionTemplate}
        selectedMotionTypes={selectedMotionTypes}
        setSelectedMotionTypes={setSelectedMotionTypes}
        motionIntensity={motionIntensity}
        setMotionIntensity={setMotionIntensity}
        motionSpeed={motionSpeed}
        setMotionSpeed={setMotionSpeed}
      />
    </>
  );
};

export default VideoAdvancedControls;